<a class="return-to-instructor-list" [routerLink]="routerLink">
  <i class="fa-solid fa-arrow-turn-left primaryColor"></i>
  <span class="pl-2">{{ 'global.back_to_list' | translate }}</span>
</a>
